<template>
  <div>
  <!-- 
    <app-main>
      <template v-slot:main-content>
  -->

	<admin-header />

	<login-banner/>
	<app-main />

  <!-- 
      </template>
    </app-main>
  -->
  </div>
</template>
<script>
import AdminHeader from 'components/baseStructure/AdminHeader'
import AppMain from 'components/baseStructure/AppMain'
import NavBar from 'components/navbar/NavBar.vue'
import NavBarLogo from 'components/navbar/NavBarLogo.vue'
import LoginBanner from 'views/login/childComps/LoginBanner.vue'
import LoginFooter from 'views/login/childComps/LoginFooter.vue'

export default {
  components: {
    AdminHeader,
    //NavBar,
    //NavBarLogo,
    LoginBanner,
    AppMain
    // LoginFooter
  },
  methods: {
    toIndex () {
      this.$router.push('index')
    }
  }
}
</script>

<style scoped src="styles/views/login/login.css">
</style>
